import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * "More information" disclosure for the open repair block confirm. react-redux-toastr renders
 * `options.component` as a component type with no props, so the copy is read from i18n here
 * rather than passed in.
 */
export const OpenRepairBlockInfo = () => {
    const { t } = useTranslation('measurementPoints');
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="open-repair-block-info">
            <button
                type="button"
                className="open-repair-block-info-toggle"
                aria-expanded={isOpen}
                aria-label={t('measurementPoints:openRepairBlockMoreInfoLabel')}
                onClick={() => setIsOpen(open => !open)}
                // the confirm closes itself on Enter/Esc anywhere inside it, so keep those off the toggle
                onKeyUp={e => e.stopPropagation()}
                onKeyDown={e => e.stopPropagation()}
            >
                ?
            </button>
            {isOpen && (
                <div className="open-repair-block-info-panel">
                    {t('measurementPoints:openRepairBlockMoreInfo')}
                </div>
            )}
        </div>
    );
};

export default OpenRepairBlockInfo;
